export default {"src":"/_next/static/image/public/images/flags/flag_1664.171c96ba4a66ea2e59a5090f0cb43149.svg","height":16,"width":24};